var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGoodOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.176 14.6504C18.176 14.6504 18.1159 15.3358 18.1013 15.4476C17.9763 16.3984 16.4499 17.2178 15.3294 17.2178C14.2747 17.2178 12.6403 17.217 11.9063 17.217C10.3141 17.217 7.19307 16.3467 7.19307 16.3467H6.24636C5.88262 16.3467 5.58789 16.0483 5.58789 15.6801L5.59114 8.80205C5.59114 8.43386 5.88587 8.13635 6.24961 8.13635H7.03068L10.4724 4.83578C10.4724 4.83578 11.4638 2.73348 11.4638 1.67823C11.4638 0.334495 12.1328 0 12.6866 0C14.1286 0 14.0506 1.65357 14.0506 1.65357C14.0506 1.65357 14.0482 2.36283 14.0482 2.7565C14.0482 5.09056 13.3321 7.52407 13.3321 7.52407H18.1037C18.6209 7.52407 19.9996 7.68762 19.9996 8.79219C19.9996 9.89676 19.6261 9.98469 19.6261 9.98469V10.9586C19.6261 11.3218 19.3963 12.0927 18.9798 12.267V13.3428C18.9798 14.2583 18.176 14.6512 18.176 14.6512V14.6504Z",
    fill: "#16BAB6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66423 7.9375H0.658473C0.294808 7.9375 0 8.23591 0 8.60402V16.0171C0 16.3853 0.294808 16.6837 0.658473 16.6837H3.66423C4.02789 16.6837 4.3227 16.3853 4.3227 16.0171V8.60402C4.3227 8.23591 4.02789 7.9375 3.66423 7.9375Z",
    fill: "#16BAB6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoodOn);
export default __webpack_public_path__ + "static/media/icon_good_on.147f7b39.svg";
export { ForwardRef as ReactComponent };